<svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="#000000"
  xmlns="http://www.w3.org/2000/svg">
  <path d="M0.999878 1.00001L12.9999 13M0.999878 13L12.9999 1.00001L0.999878 13Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
</svg>
